import { FC } from 'react'
import { useI18n } from 'utils/localisation'

import { QRCheckboxRow } from './QRCheckboxRow'

type CustomsIssuanceProps = {
  checked: boolean
  onCheck: (checked: boolean) => void
  disabled: boolean
}

export const CustomsIssuance: FC<CustomsIssuanceProps> = ({ checked, onCheck, disabled }) => {
  const { translate } = useI18n()

  return (
    <QRCheckboxRow
      name="customsIssuance"
      label={translate('quote_request-customs-issuance')}
      checked={checked}
      onCheck={onCheck}
      disabled={disabled}
      help={<small>{translate('quote_request-customs-issuance-description')}</small>}
    />
  )
}
